export const iconFontAwesomeHumanitarianSchoolCircleXmark = (
	<i className="fa-solid fa-school-circle-xmark"></i>
);
